import * as api from '@bakkt/api'
// Use openapi axios instance
import application from '../app/Application'
import axios from 'axios'
import {openTransactionDetails} from '../merchant/transactions/TransactionsHelper'
import {URLParam} from '../app/AppState'
import {validUUID} from './helper'
import Alert from './components/Alert'

const SERVER_URL = window['SERVER_URL'] === '{{SERVER_URL}}' ? process.env.REACT_APP_SERVER_URL : window['SERVER_URL']

export const redirectToLogin = () => {
	axios.get(`${SERVER_URL}/web/login-redirect?client=merchant`).then(response => {
		if (response.headers['content-type'] === 'text/html;charset=UTF-8')
			window.location = response.request.responseURL
	})
}

const globalErrorHandler = (error: any) => {
	application.respenseReceived()
	if (error.response && error.response.status === 401) {
		redirectToLogin()
	}
	return Promise.reject({...error})
}

export const logout = () => {
	axios.post(`${SERVER_URL}/web/logout?client=merchant`).then(response => {
		localStorage.removeItem('portal-type')
		window.location.reload()
	})
}

/*
 * Takes an array of fusionAuthRefs to destroy the sessions for on a permissions change
 */
export const destroyUserSessions = async userRefArray => {
	return axios.post(`${SERVER_URL}/web/destroy-sessions?client=merchant`, {
		fusionAuthRefs: userRefArray,
	})
}

export const destroyPartnerUserSessions = async userRefArray => {
	return axios.post(`${SERVER_URL}/web/destroy-sessions?client=partner`, {
		fusionAuthRefs: userRefArray,
	})
}

export const getPortalType = () => {
	if (!localStorage.getItem('portal-type')) {
		return axios.get(`${SERVER_URL}/partner-type`).then(response => {
			if (response.data && response.data.type) {
				localStorage.setItem('portal-type', response.data.type)
			}
		})
	}
}

axios.interceptors.request.use(req => {
	application.requestSent()
	return req
})

const globalSuccessHandler = (response: any) => {
	application.respenseReceived()

	return response
}
const baseUrl = SERVER_URL

axios.interceptors.response.use(globalSuccessHandler, globalErrorHandler)
// send session cookie
axios.defaults.withCredentials = true

const configuration: api.Configuration = {
	baseOptions: {},
}

export const attachmentsDataList = async (file: File[]) => {
	let promises = []
	file.map(key => {
		const formData = new FormData()
		formData.append('fileToUpload', key)
		promises.push(
			axios
				.post(`${baseUrl}/merchant-portal/disputes/upload-attachment`, formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				})
				.catch(reason => {
					console.log('reason    ', reason)
				}),
		)
	})
	const promisesResp = await Promise.all(promises)
	return promisesResp.map(res => (res && res.data && res.data.payload) || null).filter(el => el != null)
}

const openTransactionDetailsTab = transactionId => {
	if (transactionId && !validUUID(transactionId)) {
		Alert.error('Invalid Id !', transactionId)
	} else {
		openTransactionDetails(transactionId)
	}
	localStorage.removeItem('url-parameter')
}

export const openURLTab = async () => {
	//Get Url info from local storage and open transaction tab.
	const searchQuery: URLParam = JSON.parse(localStorage.getItem('url-parameter'))

	const hasTransactionId = searchQuery?.paramName == 'transaction-id'
	hasTransactionId && openTransactionDetailsTab(searchQuery?.paramId)
}

export const transactionApi = api.MerchantPortalTransactionControllerApiFactory(configuration, baseUrl)

export const disputeApi = api.MerchantPortalDisputeControllerApiFactory(configuration, baseUrl)

export const reportApi = api.MerchantPortalReportControllerApiFactory(configuration, baseUrl)

export const usersApi = api.MerchantUserRoleManagementControllerApiFactory(configuration, baseUrl)

export const managementApi = api.MerchantManagementControllerApiFactory(configuration, baseUrl)

export const partnerTransactionApi = api.PartnerTransactionControllerApiFactory(configuration, baseUrl)

export const partnerConsumerApi = api.PartyControllerApiFactory(configuration, baseUrl)

export const partnerUserApi = api.PartnerUserRoleControllerApiFactory(configuration, baseUrl)

export const partnerApi = api.PartnerControllerApiFactory(configuration, baseUrl)

export const partnerDashboardMetricsApi = api.DashBoardMetricsControllerApiFactory(configuration, baseUrl)

export const partnerControllerApi = api.PartnerControllerApiFactory(configuration, baseUrl)
